import type { RadioOptionValue } from './types'

/**
 * Without a set testID a card keeps the unscoped `radio-card-<value>` id existing tests
 * rely on. With one, cards are scoped to their set, so two sets sharing a value stay
 * apart, like SearchableList options.
 */
export const radioCardTestID = (setTestID: string | undefined, value: RadioOptionValue) =>
  setTestID ? `${setTestID}-radio-card-${value}` : `radio-card-${value}`
